import React from 'react'

import { IoIosClose } from 'react-icons/io'

import { Flex, IconButton } from '@chakra-ui/react'

import { FileThumbnail } from '@/components/ui'

import { ImageThumbnail } from './ImageThumbnail'
import { PdfThumbnail } from './PdfThumbnail'
import { VideoThumbnail } from './VideoThumbnail'

interface MediaThumbnailIProps {
  file: File
  removeFile: (file: File) => void
}

export const MediaThumbnail = ({ file, removeFile }: MediaThumbnailIProps) => {
  const isImage = file.type.startsWith('image/')
  const isPdf = file.type === 'application/pdf'
  const isVideo = file.type.startsWith('video/')

  const handleRemoveFile = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.stopPropagation()
    removeFile(file)
  }

  return (
    <Flex
      alignItems='center'
      className='group relative'
      justifyContent='center'
    >
      <IconButton
        aria-label='Remove'
        className='rounded-full close-button absolute top-[-8px] right-[-5px] invisible group-hover:visible'
        colorScheme='gray'
        icon={<IoIosClose size={18} />}
        onClick={handleRemoveFile}
        size='20px'
        zIndex={10}
      />
      {isImage && <ImageThumbnail imgUrl={URL.createObjectURL(file)} />}
      {isPdf && <PdfThumbnail file={file} />}
      {isVideo && <VideoThumbnail videoFile={file} />}
      {/* Formats with no inline preview still need to be visible before upload */}
      {!isImage && !isPdf && !isVideo && (
        <FileThumbnail name={file.name} width={137} />
      )}
    </Flex>
  )
}
